import * as TYPES from './type';
export default {
  //课中活动讨论
  [TYPES.SHOW_LIST](state, { result }) {
    state.showList = result.result
  },
  [TYPES.SHOW_INFO](state, { result, type }) {
    state.showInfo[type] = result.result
  },
}